import React, { useEffect, useRef } from 'react'
import { Alert } from '@smooth-ui/core-sc'
import { useMutation } from '@apollo/react-hooks'
import { Link } from 'react-router-dom'

import trackGMT from 'helpers/gtm'
import { SpinnerButton, P } from 'components/Elements/index'
import { LoadingSpinnerInline } from 'components/Spinner/Spinner'
import config from 'config'

import routeConfig from 'routeConfig'

import { MUTATION_ADD } from 'helpers/queries'

const TraingLog = ({ title, seconds, postId, onSaved }) => {
  const [addTrainginLog, { data, loading, error }] = useMutation(MUTATION_ADD)
  const storeLog = async () => {
    try {
      const variables = {
        title,
        kcal: parseInt(seconds * config.kcalPerSecond),
        seconds: seconds,
        postId: postId
      }
      const payload = await addTrainginLog({
        variables
      })
      onSaved(payload)
    } catch (error) {
      trackGMT({
        event: 'custom',
        category: 'Video',
        action: 'Error store log',
        label: JSON.stringify(error)
      })
    }
  }
  const throttled = useRef(storeLog)
  useEffect(() => {
    throttled.current()
  }, [throttled])
  if (loading) {
    return (
      <Alert variant="success" as="div">
        <LoadingSpinnerInline>
          Lagrer økt til din treningdagbok
        </LoadingSpinnerInline>
      </Alert>
    )
  }
  if (data) {
    return (
      <Alert variant="success">
        Treningsøkten er lagret i din{' '}
        <Link
          style={{ textDecoration: 'underline' }}
          to={routeConfig.mypageLog}
        >
          treningsdagbok
        </Link>
      </Alert>
    )
  }
  if (error) {
    return (
      <Alert as="div">
        <P>Feil: Kunne ikke lagre treningsøkt.</P>
        <SpinnerButton
          onClick={storeLog}
          working={loading}
          text="Forsøk igjen"
        />
      </Alert>
    )
  }
  return <p>Treningslog</p>
}

export default TraingLog
